export default __webpack_public_path__ + "static/media/Newspaper-Publication-Un-Audited-Financial-Results-Q1FY27.6593a523.pdf";